import React, { Fragment } from "react";
import { Badge, Layout, Spin, Typography } from "antd";
import { Client as ConversationsClient } from "@twilio/conversations";

import "../../../../../assets/Conversation.css";
import "../../../../../assets/ConversationSection.css";
import '../../../../../assets/style.css';

import TwilioConversation from "./TwilioConversation";
import { TwilioConversationList } from "./TwilioConversationList";
import { HeaderItem } from "./HeaderItem";
import 'antd/dist/reset.css';
const { Content, Sider, Header } = Layout;
const { Text } = Typography;

const TWILIO_TOKEN_GEN_URL = process.env.REACT_APP_CHAT_API + "/twilio-token";
const TWILIO_END_CONVERSATION = process.env.REACT_APP_CHAT_API + "/endTwilioConversation";

class TwilioConversationApp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            token: null,
            statusString: null,
            conversationsReady: false,
            conversations: [],
            selectedConversationSid: null,
            newMessage: ""
        };
    }

    componentDidMount = () => {
        this.getToken(this.props.userId);
        this.setState({ statusString: "Fetching credentials…" });
    };

    closeConversation = (item, event) => {
        // if (event.target.tagName == 'svg') {
        fetch(TWILIO_END_CONVERSATION, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ twilioConversationId: item.sid })
        }).then(res => {
            this.setState({
                conversations: [...this.state.conversations.filter((it) => it !== item)]
            });
        });

        // }
    }

    onConversationClick = (item, event) => {
        // if (event.target.tagName === 'STRONG') {
        this.setState({ selectedConversationSid: item.sid });
        // }
    }

    getToken = (userId) => {

        var identityBody = {
            identity: userId
        };

        fetch(TWILIO_TOKEN_GEN_URL, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(identityBody)
        }).then(tokenResponse => {
            tokenResponse.json().then(twilioToken => {
                this.props.twilioStartChat();
                this.setState({ token: twilioToken.accessToken }, this.initConversations);
            })
        });

    };

    initConversations = async () => {
        window.conversationsClient = ConversationsClient;
        this.conversationsClient = await ConversationsClient.create(this.state.token);
        this.setState({ statusString: "Connecting to Twilio…" });

        this.conversationsClient.on("connectionStateChanged", (state) => {
            if (state === "connecting")
                this.setState({
                    statusString: "Connecting to Twilio…",
                    status: "default"
                });
            if (state === "connected") {
                this.setState({
                    statusString: "You are connected.",
                    status: "success"
                });
            }
            if (state === "disconnecting")
                this.setState({
                    statusString: "Disconnecting from Twilio…",
                    conversationsReady: false,
                    status: "default"
                });
            if (state === "disconnected")
                this.setState({
                    statusString: "Disconnected.",
                    conversationsReady: false,
                    status: "warning"
                });
            if (state === "denied")
                this.setState({
                    statusString: "Failed to connect.",
                    conversationsReady: false,
                    status: "error"
                });
        });

        this.conversationsClient.on("conversationJoined", (conversation) => {
            const newConversations = [...this.state.conversations, conversation]
            newConversations.sort((a, b) => b.channelState.dateUpdated - a.channelState.dateUpdated);
            this.setState({ conversations: newConversations });
            if (newConversations.length > 0) {
                this.setState({ selectedConversationSid: newConversations[0].sid });
            }
        });
        this.conversationsClient.on("conversationLeft", (thisConversation) => {
            this.setState({
                conversations: [...this.state.conversations.filter((it) => it !== thisConversation)]
            });
        });

    };

    render() {
        const { conversations, selectedConversationSid, status } = this.state;
        const selectedConversation = conversations.find(
            (it) => it.sid === selectedConversationSid
        );

        return (
            <Fragment>
                <div className="conversations-window-wrapper">
                    <Layout className="conversations-window-container">
                        <Header
                            style={{ display: "flex", alignItems: "center", padding: 0 }}
                        >
                            <div
                                style={{
                                    maxWidth: "300px",
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <HeaderItem style={{ paddingRight: "0", display: "flex" }}>
                                    <img style={{ width: '75px', height: '50px' }} src="/assets/img/bmb-final-logo-04.png" />
                                </HeaderItem>
                                <HeaderItem>
                                    <Text strong style={{ color: "white" }}>
                                        Ongoing  Conversations
                      </Text>
                                </HeaderItem>
                            </div>
                            <div style={{ display: "flex", width: "100%" }}>
                                <HeaderItem>
                                    <Text strong style={{ color: "white" }}>
                                        {selectedConversation &&
                                            (selectedConversation.friendlyName || selectedConversation.sid)}
                                    </Text>
                                </HeaderItem>
                                <HeaderItem style={{ float: "right", marginLeft: "auto" }}>
                                    <span
                                        style={{ color: "white" }}
                                    >{` ${this.state.statusString}`}</span>
                                    <Badge
                                        dot={true}
                                        status={this.state.status}
                                        style={{ marginLeft: "1em" }}
                                    />
                                </HeaderItem>
                            </div>
                        </Header>
                        <Layout>
                            <Sider theme={"light"} width={250} style={{ border: '1px solid #d9d9d9' }}>
                                <TwilioConversationList
                                    conversations={conversations}
                                    selectedConversationSid={selectedConversationSid}
                                    onConversationClick={this.onConversationClick}
                                />
                            </Sider>
                            <Content className="conversation-section" style={{ margin: '0', marginTop: '10px' }}>
                                <div id="SelectedConversation"> {selectedConversation ? (<TwilioConversation
                                    conversationProxy={selectedConversation}
                                    myIdentity={this.props.userId}
                                    closeConversation={this.closeConversation}
                                />) : null}</div>
                            </Content>
                        </Layout>
                    </Layout>
                </div>
            </Fragment>
        );
    }
}
export default TwilioConversationApp;